// extracted by mini-css-extract-plugin
export default {"actionButtons":"domestic-non-consolidation_actionButtons__84YBu"};